import React from 'react'
import {DragSource} from 'react-dnd'
import PropTypes from 'prop-types'
import styles from './styles.css'
import {findDOMNode} from 'react-dom'
import {Resizable} from 'react-resizable'
import autobind from 'autobind-decorator'
import Signature from './Signature'
import Text from './Text'
import Menu from './Menu'
import Checkbox from './Checkbox'

const fieldSource = {
  canDrag(props, monitor) {
    return !props.resizing
  },
  beginDrag(props, monitor, component) {
    component.setState({dragging: true})
    if (props.closeMenu) {
      props.closeMenu()
    }
    // eslint-disable-next-line
    const componentRect = findDOMNode(component).getBoundingClientRect()
    return {
      width: componentRect.width,
      height: componentRect.height,
      top: componentRect.top,
      left: componentRect.left,
      field: props.field,
      type: props.type
    }
  },
  endDrag(props, monitor, component) {
    component.setState({dragging: false})
  }
}

function collect(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging()
  }
}

@DragSource('field', fieldSource, collect)
export default class SignField extends React.Component {
  static propTypes = {
    connectDragSource: PropTypes.func,
    isDragging: PropTypes.bool,
    field: PropTypes.object,
    page: PropTypes.object,
    height: PropTypes.number,
    onUpdate: PropTypes.func,
    delete: PropTypes.func,
    setResizing: PropTypes.func,
    type: PropTypes.string,
    template: PropTypes.object,
    menuOpened: PropTypes.bool,
    openMenu: PropTypes.func,
    closeMenu: PropTypes.func
  }

  state = {}

  getStyle() {
    if (!this.props.field) return {}

    let currentWidth = this.props.height * this.props.page.width / this.props.page.height
    let propHeigth = this.props.height
    if(this.props.field && this.props.field.textSize){
        console.log("Viene textSize");
        if(this.props.field.textSize === 'medium'){
          propHeigth=propHeigth*2
          //currentWidth = currentWidth*1.3
        } else if(this.props.field.textSize === 'large'){
          propHeigth=propHeigth*3
          //currentWidth = currentWidth*1.5
        }
    }

    return {
      backgroundColor: this.state.dragging ? '#fff' : 'transparent',
      position: 'absolute',
      top: this.props.field.y * 100 + '%',
      left: this.props.field.x * 100 + '%',
      width: (this.state.width || this.props.field.width) * currentWidth,
      height: (this.state.height || this.props.field.height) * propHeigth
    }
  }

  @autobind
  onResizeStart(event, {element, size}) {
    this.props.setResizing(true)
  }

  @autobind
  onResizeStop(event, {element, size}) {
    this.props.setResizing(false)
    const currentWidth = this.props.height * this.props.page.width / this.props.page.height

    const width = size.width / currentWidth
    const height = size.height / this.props.height

    this.props.onUpdate({width, height})
    this.setState({width: null, height: null})
  }

  @autobind
  onResize(event, {element, size}) {
    const currentWidth = this.props.height * this.props.page.width / this.props.page.height

    const width = size.width / currentWidth
    const height = size.height / this.props.height

    this.setState({width, height})
  }

  getMinConstraints() {
    if (this.props.type === 'signature') return [100, 50]
    if (this.props.type === 'text') return [20, 20]
  }

  getMaxConstraints() {
    if (this.props.type === 'signature') return [400, 200]
    if (this.props.type === 'text') return [Infinity, 20]
  }

  renderInner(menu) {
    if (this.props.type === 'signature') {
      return <Signature field={this.props.field} menu={menu} />
    } else if (this.props.type === 'text') {
      return <Text field={this.props.field} menu={menu} />
    } else {
      return <Checkbox field={this.props.field} />
    }
  }

  renderNoField() {
    return this.props.connectDragSource(
      <div style={this.getStyle()} className={styles.container}>
        {this.renderInner(true)}
      </div>
    )
  }

  renderMenu() {
    if (!this.props.menuOpened) return
    return (
      <Menu
        field={this.props.field}
        template={this.props.template}
        onUpdate={this.props.onUpdate}
        delete={this.props.delete}
      />
    )
  }

  renderResizable() {
    if (this.props.type === 'checkbox') {
      return (
        <div
          style={{
            height: this.getStyle().height,
            width: this.getStyle().width
          }}
          className={styles.container}
          onClick={this.props.openMenu}
        >
          {this.renderInner()}
        </div>
      )
    }
    return (
      <Resizable
        minConstraints={this.getMinConstraints()}
        maxConstraints={this.getMaxConstraints()}
        height={this.getStyle().height}
        width={this.getStyle().width}
        onResizeStart={this.onResizeStart}
        onResize={this.onResize}
        onResizeStop={this.onResizeStop}
      >
        <div
          style={{
            height: this.getStyle().height,
            width: this.getStyle().width
          }}
          className={styles.container}
          onClick={this.props.openMenu}
        >
          {this.renderInner()}
        </div>
      </Resizable>
    )
  }

  render() {
    if (!this.props.field) return this.renderNoField()
    return this.props.connectDragSource(
      <span style={this.getStyle()}>
        {this.renderMenu()}
        {this.renderResizable()}
      </span>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Sign/PrepareTemplate/Field/index.js